export const landingCopy = {
  hero: {
    headline: "Intelligent debt recovery. Automated workflows.",
    subhead: "Streamline debt collection with multi-channel campaigns, AI-powered automation, and real-time analytics — recover more, faster.",
  },
  features: [
    {
      name: "Multi-Channel Campaigns",
      benefit: "Launch automated campaigns across SMS, Email, WhatsApp, Voice, IVR, and AI Calls with intelligent routing",
      icon: "MessageSquare",
    },
    {
      name: "Debt Recovery Workflows",
      benefit: "Create automated recovery flows with scheduled actions, payment tracking, and intelligent status management",
      icon: "Workflow",
    },
    {
      name: "Customer Management",
      benefit: "Import, segment, and manage customer data with advanced filtering, batch processing, and segmentation",
      icon: "Users",
    },
    {
      name: "Real-time Analytics",
      benefit: "Track campaign performance, recovery rates, agent activity, and geographic insights with comprehensive dashboards",
      icon: "BarChart3",
    },
    {
      name: "AI-Powered Assistant",
      benefit: "Intelligent AI chatbot handles customer queries, FAQ matching, and escalates to live agents when needed",
      icon: "Activity",
    },
    {
      name: "Helpdesk & Followups",
      benefit: "Manage customer support tickets, track follow-ups, and maintain complete communication history",
      icon: "FileText",
    },
    {
      name: "Batch Processing",
      benefit: "Automated batch creation and processing with real-time progress tracking and intelligent allocation",
      icon: "RefreshCw",
    },
    {
      name: "Comprehensive Reports",
      benefit: "Generate detailed reports on campaigns, agent activity, CDR, IVR performance, and recovery analytics",
      icon: "TrendingUp",
    },
  ],
  howItWorks: [
    {
      step: 1,
      title: "Connect Your Accounts",
      description: "Securely link your bank accounts and payment systems in minutes",
      icon: "Link",
    },
    {
      step: 2,
      title: "Automate Your Workflow",
      description: "Set up rules for invoicing, reconciliation, and cash flow tracking",
      icon: "Zap",
    },
    {
      step: 3,
      title: "Make Better Decisions",
      description: "Use real-time insights to optimize cash flow and plan for growth",
      icon: "Target",
    },
  ],
  trustedLogos: [
    {
      src: "/images/Frame 1261153507.png",
      alt: "Trusted Partner 1",
      width: 200,
      height: 80,
    },
    {
      src: "/images/Frame 1261153519.png",
      alt: "Trusted Partner 2",
      width: 200,
      height: 80,
    },
  ],
  testimonials: [
    {
      quote: "GrowFinx transformed our debt recovery process. We increased recovery rates by 35% and reduced manual effort by 60% with automated campaigns. The AI-powered chatbot handles most customer queries, freeing up our team to focus on complex cases.",
      author: "Sarah Chen",
      role: "Collections Manager",
      company: "Financial Services Co.",
      avatar: "SC",
      logo: {
        src: "/images/Frame 1261153507.png",
        alt: "Financial Services Co.",
        width: 150,
        height: 60,
      },
    },
    {
      quote: "The multi-channel campaign system and real-time analytics give us complete visibility into our recovery operations. We can now track performance across SMS, Email, WhatsApp, and Voice channels in one dashboard. Game changer for our team.",
      author: "Michael Rodriguez",
      role: "Operations Director",
      company: "Recovery Solutions",
      avatar: "MR",
      logo: {
        src: "/images/Frame 1261153519.png",
        alt: "Recovery Solutions",
        width: 150,
        height: 60,
      },
    },
  ],
  security: [
    "Bank-grade encryption (256-bit SSL/TLS)",
    "ISO 9001 & ISO 27001 (ISMS) certified",
    "Role-based access control (RBAC)",
    "Multi-factor authentication (MFA)",
    "Comprehensive audit logging",
    "Data encryption at rest and in transit",
    "Daily automated backups with point-in-time recovery",
    "Regular security audits and penetration testing",
    "Network security with firewalls and DDoS protection",
    "99.9% uptime SLA with redundant infrastructure",
  ],
  footer: {
    product: {
      title: "Product",
      links: [
        { label: "Features", href: "#features" },
        { label: "Pricing", href: "/pricing" },
        { label: "Security", href: "#security" },
        { label: "Integrations", href: "#" },
      ],
    },
    resources: {
      title: "Resources",
      links: [
        { label: "Documentation", href: "#" },
        { label: "API Reference", href: "#" },
        { label: "Help Center", href: "#" },
        { label: "Blog", href: "#" },
      ],
    },
    company: {
      title: "Company",
      links: [
        { label: "About", href: "#about" },
        { label: "Careers", href: "#" },
        { label: "Contact", href: "#" },
        { label: "Partners", href: "#" },
      ],
    },
    legal: {
      title: "Legal",
      links: [
        { label: "Privacy Policy", href: "#" },
        { label: "Terms of Service", href: "#" },
        { label: "Cookie Policy", href: "#" },
      ],
    },
    copyright: `© ${new Date().getFullYear()} GrowFinx. All rights reserved.`,
  },
  pricing: {
    teaser: {
      title: "Simple, transparent pricing",
      subtitle: "Start free, scale as you grow",
      highlight: "Free tier includes core features with no credit card required",
    },
  },
  cta: {
    primary: "Get Started — It's free",
    secondary: "Login",
    demo: "See a demo",
    dashboard: "Go to Dashboard",
  },
};

